import React, { Fragment, useContext, useEffect, useState } from "react";
import { IWalkaroundCheckList, RequestStatus, Walkaround, WalkaroundCheckList, api } from "../../../logic/api";

import { Button } from "@mui/material";
import { SessionContext } from "../../../utility/useSession";
import flex from "../../../styles/flex";
import { ProgressDialog } from "../../../components/notifications/progressDialog/progressDialog";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { WaCheckListItem } from "./WaCheckListItem";
import { useTranslation } from "react-i18next";

export const WalkaroundCheckListManager: React.FC = () => {
    const session = useContext(SessionContext);

    const [editTarget, setEditTarget] = useState<WalkaroundCheckList | null>(null);
    const [selected, setSelected] = useState<WalkaroundCheckList | null>(null);
    const { t } = useTranslation();

    const [listWalkaroundsParams, setListWalkaroundsParams] = useState<IWalkaroundCheckList>({
        parentId: selected?.id,
        includeInactive: false,
    });

    const refreshView = () => setListWalkaroundsParams({ ...listWalkaroundsParams });

    const fetchList = api.hooks.walkaroundCheckList.listUnpaginated();
    const setActive = api.hooks.walkaroundCheckList.setActive();
    const createNew = api.hooks.walkaroundCheckList.save();

    const [items, setItems] = useState<WalkaroundCheckList[]>([]);
    const [walkarounds, setWalkarounds] = useState<Walkaround[]>([]);

    useEffect(() => {
        fetchList.send(session.current.context, listWalkaroundsParams);
    }, [listWalkaroundsParams]);


    useEffect(() => {
        setEditTarget(null);
        setSelected(null);
        setItems([]);
        refreshView();
    }, [session.current.site]);


    useEffect(() => {

        if (fetchList.status == RequestStatus.loaded) {
            setItems(fetchList.data?.items ?? []);
            setWalkarounds(fetchList.data?.walkarounds ?? []);
        }

    }, [fetchList.status]);

    const uniqueId = () => {
        //generates a unique id 18 characters long using base36
        return Math.random().toString(36).substring(2, 18);
    };

    const handleAddNew = () => {
        const newItem = {
            parentId: selected?.id,
            active: true,
            ordinal: 0,
            qrCode: uniqueId(),
            config: {
                name: "",
                direction: "",
            }
        };
        setItems([...items, newItem]);
        setEditTarget(newItem);
    };

    return <Fragment>

        <div style={{ width: "100%", maxWidth: 1200, display: "inline-block" }}>
            <div style={{ textAlign: "left" }}>
                <div style={flex.flexRows}>
                    <div style={flex.flexFill}>
                        {selected == null && (
                            <h2>{t("walkarounds.checklists")}</h2>
                        )}
                        {selected != null && (
                            <h2><a style={{ color: "black" }} href="#" onClick={() => {
                                setListWalkaroundsParams({ ...listWalkaroundsParams, parentId: undefined });
                                setSelected(null);
                                setEditTarget(null);
                            }}>{t("walkarounds.checklists")}</a> &gt; {selected?.config?.name ?? ""}</h2>
                        )}


                    </div>

                </div>
                <div style={{ height: 50 }}></div>

                <div>
                    {items.map((item, index) => {
                        return <WaCheckListItem
                            key={item.id}
                            editing={item.id == editTarget?.id}
                            hasSelection={editTarget != null}
                            index={index}
                            isLast={index == items.length - 1}
                            item={{
                                ...item,
                                config: {
                                    ...item.config,
                                }
                            }}
                            walkarounds={walkarounds}
                            onEdit={() => {
                                setEditTarget(item);
                            }}
                            onCancel={() => {
                                if (item.id == null) {
                                    //remove the new item since it was cancelled
                                    setItems(items.filter(x => x.id != null));
                                }
                                setEditTarget(null);
                            }}
                            onSave={(w, manageSubItems) => {
                                if (manageSubItems) {
                                    setItems([]);

                                    setEditTarget(null);
                                    setSelected(w);
                                    setListWalkaroundsParams({ ...listWalkaroundsParams, parentId: w.id });
                                } else {
                                    setEditTarget(null);
                                    refreshView();
                                }
                            }}
                            onOrdinalUpdated={() => {
                                refreshView();
                            }}
                            onDelete={() => {
                                if (!item.id) { return }
                                setActive.send(session.current.context, {
                                    active: false,
                                    id: item.id
                                }, () => {
                                    setEditTarget(null);
                                    refreshView();
                                });
                            }}
                            onRestore={() => {
                                if (!item.id) { return }
                                setActive.send(session.current.context, {
                                    active: true,
                                    id: item.id
                                }, () => {
                                    refreshView();
                                });
                            }}

                        ></WaCheckListItem>;
                    })}
                    {(items.length == 0 && fetchList.status == RequestStatus.loaded) && (<div style={{ padding: 20, backgroundColor: "#eee" }}>
                        {selected?.id == null ? t("walkarounds.noChecklists") : t("walkarounds.noChecks")}
                    </div>)}
                    {(editTarget == null) && (<div style={{ textAlign: selected?.id == null ? "left" : "right" }}>
                        <Button
                            style={{ marginLeft: 20, marginTop: 20, marginBottom: 50, width: 200 }}
                            variant="contained"
                            color="secondary"
                            onClick={handleAddNew}>{t("webhooks.addNew")}</Button>
                    </div>)}
                </div>


                <ProgressDialog status={setActive.status}></ProgressDialog>
                <ErrorDialog err={setActive.err}></ErrorDialog>

                <ProgressDialog status={createNew.status}></ProgressDialog>
                <ErrorDialog err={createNew.err}></ErrorDialog>


            </div>
        </div>
    </Fragment>;
}
